export default __webpack_public_path__ + "static/media/CSI_Logo.1b40b3e0.png";